import { render } from "./StockOperationsDialog.vue?vue&type=template&id=98bd7c5a&scoped=true"
import script from "./StockOperationsDialog.vue?vue&type=script&lang=ts"
export * from "./StockOperationsDialog.vue?vue&type=script&lang=ts"

import "./StockOperationsDialog.vue?vue&type=style&index=0&id=98bd7c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-98bd7c5a"

export default script